// extracted by mini-css-extract-plugin
export default {"Vcard":"Transaction_Vcard__83c6B","VAcctTxt":"Transaction_VAcctTxt__fGXxE","VFundTxt":"Transaction_VFundTxt__mg9C8","VBank":"Transaction_VBank__H5Ud9"};